import {useState, useEffect} from "react";
import Geocode from 'react-geocode';

const districts = require("./regionMap.json");

const findDistrict= ( userZip ) => {
    const district = districts.find((z) => String(z.Zip) === userZip);
  if (district) {
    return district.District;
  } else {
    return "OOS";
  }
}

//Custom hook for getting user's address and lat, long from
//Google geocoding api

export const useGetUser = (location, setFilters, updateFilters) => {
  // debugger
    const [ user, setUser ] = useState(null);

    useEffect(() => {
      const getUserInfo = async ( location ) => {
            // if (!location) return null;

        Geocode.setApiKey(process.env.REACT_APP_MAPS_API_KEY);
        Geocode.setRegion("US")

        //Google maps api does not return a zip code directly
        //so we have to use this regex to extract it from formatted_address
        let re = /\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d/

        const getAddress = await Geocode.fromAddress( location );
        const formatted_address = getAddress.results[0].formatted_address;
        const lat = getAddress.results[0].geometry.location.lat;
        const long = getAddress.results[0].geometry.location.lng;


        const getZip = await Geocode.fromLatLng(lat, long);
        const result = getZip.results
        const address = result.find((x) => x.formatted_address.match(re))
        const matches = address.formatted_address.match(re);
        const zip = matches[0]
        const district = findDistrict(zip);

        setUser({address: formatted_address,
                    lat: lat,
                    long: long,
                    zip: zip,
                 district: district, });

        setFilters(updateFilters([{type: 'location', args: 1}]))
      }

      if (!location) {
        setUser(null);

        return null;
      } else {
        getUserInfo(location);
      }
        
    }, [location]);

  return user;
}
